module.exports = __webpack_public_path__ + "img/67.f55cfd26.png";